module.exports = __webpack_public_path__ + "static/media/help-menu.2c841510.svg";